import { Box, Button, Collapse, FormControl, FormErrorMessage, FormLabel, Heading, Highlight, IconButton, Input, InputGroup, InputRightElement, Link, Text, Tooltip } from '@chakra-ui/react';
import { useFormik } from 'formik';
import { useState } from 'react';
import { PiPaperPlaneRightFill } from 'react-icons/pi';
import { RiEyeLine, RiEyeOffLine } from 'react-icons/ri';
import { useDispatch, useSelector } from 'react-redux';
import { Link as RouterLink } from 'react-router-dom';
import ModalLoading from '../../../../../components/Loader/ModalLoader';
import { trackSignIn } from '../../../../../helper/utils/eventTrackGA';
import { urlNavigate } from '../../../../../helper/utils/navigation';
import { doSuccess } from '../../../../../redux/responseHandling/responseHandling.actions';
import { doCheckEmail, doLogin } from '../../../../../redux/waiver/waiver.actions';
import useOnlineSales from '../../../hooks/useOnlineSales';

export default function CustomerVerif({ isOpen }) {
    const dispatch = useDispatch();

    const [showPassword, setShowPassword] = useState(false);
    const handlePasswordClick = () => setShowPassword(!showPassword);

    const { loadingSignIn: loading = false } = useSelector((s) => s?.waiver);
    const { brand } = useOnlineSales();

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            email: '',
            password: '',
        },
        onSubmit: (values) => {
            const payload = {
                ...values,
                brand: String(brand['brandName'] || '')
                    .trim()
                    .toLowerCase(),
            };

            dispatch(
                doLogin(payload, null, () =>
                    dispatch(
                        doCheckEmail(values, null, (data) => {
                            trackSignIn();
                            dispatch(doSuccess(`Welcome, ${data['fullname'] || ''}!`, '', 'Verify'));
                        }),
                    ),
                ),
            );
        },
    });

    return (
        <>
            <ModalLoading loading={loading} />

            <Collapse in={isOpen} animateOpacity>
                <Box>
                    <Box mb={5}>
                        <Heading fontSize={{ base: 'xl', md: '2xl' }} textAlign='left' mb={3}>
                            Log In to Continue
                        </Heading>
                        <Text fontSize='md' color='black' lineHeight='1.3' mb={5} textAlign='left'>
                            Use your registered email to proceed. Login verifies your waiver and is not the same as Membership.
                        </Text>
                    </Box>
                    <Box mb={3}>
                        <FormControl isInvalid={!!formik?.errors.email && formik?.touched.email}>
                            <FormLabel fontSize='sm' color='black' lineHeight='1.3'>
                                Email
                            </FormLabel>
                            <Input size='lg' id='email' name='email' variant='filled' type='email' py={7} onChange={formik.handleChange} value={formik?.values?.email ?? ''} placeholder='Enter email address' fontSize='14px' />
                            <FormErrorMessage>{formik?.errors.email}</FormErrorMessage>
                        </FormControl>
                    </Box>
                    <Box mb={2}>
                        <FormControl isInvalid={!!formik?.errors.password && formik?.touched.password}>
                            <FormLabel fontSize='sm' color='black' lineHeight='1.3'>
                                Password
                            </FormLabel>
                            <InputGroup size='lg'>
                                <Input id='password' name='password' variant='filled' type={showPassword ? 'password' : 'text'} py={7} onChange={formik.handleChange} value={formik?.values?.password ?? ''} placeholder='Enter password' fontSize='14px' />
                                <InputRightElement h='full' pr={3} transition='all 0.25s ease-out'>
                                    <Tooltip label={showPassword ? 'Show' : 'Hide'}>
                                        <IconButton icon={showPassword ? <RiEyeLine /> : <RiEyeOffLine />} bg='transparent' _hover={{ bg: 'transparent' }} color={showPassword ? 'gray.400' : 'gray.600'} onClick={handlePasswordClick} />
                                    </Tooltip>
                                </InputRightElement>
                            </InputGroup>
                            <FormErrorMessage>{formik?.errors.password}</FormErrorMessage>
                        </FormControl>
                    </Box>
                    <Box w='full' mb={7}>
                        <Link as={RouterLink} to={urlNavigate('forgot-password')} fontSize='sm' _hover={{ textDecoration: 'none' }}>
                            <Highlight query={['Forget Password?']} styles={{ color: 'primary.500', fontWeight: 600 }}>
                                Forget Password?
                            </Highlight>
                        </Link>
                    </Box>
                    <Box w='full' mt={4}>
                        <Button variant='solid' w='full' isDisabled={formik.values.email.length === 0 || formik.values.password.length === 0} colorScheme='primary' rightIcon={<PiPaperPlaneRightFill />} isLoading={loading} size='lg' fontSize='15px' type='button' onClick={formik.handleSubmit}>
                            Log Me In!
                        </Button>
                    </Box>
                </Box>
            </Collapse>
        </>
    );
}
